module.exports = __webpack_public_path__ + "static/media/about-2-bg.74e067b8.jpg";